import { useEffect } from 'react';

interface UseClickOutsideToCloseMenuProps {
  elementId: string;
  condition: boolean;
  onClose: () => void;
}

/**
 * Hook to close a menu when clicking outside the specified element (by id), unless condition is true.
 */
export function useClickOutsideToCloseMenu({ elementId, condition, onClose }: UseClickOutsideToCloseMenuProps) {
  useEffect(() => {
    if (condition) {
      return undefined;
    }

    function handleClickOutside(event: MouseEvent) {
      if (!event.target || !(event.target instanceof HTMLElement)) {
        return;
      }

      if (!event.target.closest(`#${elementId}`)) {
        event.stopImmediatePropagation();
        onClose();
      }
    }

    document.addEventListener('click', handleClickOutside, { capture: true });

    return () => {
      document.removeEventListener('click', handleClickOutside, { capture: true });
    };
  }, [elementId, condition, onClose]);
}
